export default "__VITE_ASSET__BylXOaZw__"